import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityClient } from "../../entity/EntityClient";

export class DtoClientsPostReq extends EntityClient {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
